import { createReducer } from 'typesafe-actions';
import actions, { SessionsAction } from './actions';
import { SessionsState } from './types';

export const initState: SessionsState = { sessionId: '' };

const reducer = createReducer<SessionsState, SessionsAction>(initState)
  .handleAction(actions.fetch.request, (state) => ({
    ...state,
    isFetching: true,
  }))
  .handleAction(actions.fetch.failure, (state, { payload }) => ({
    ...state,
    isFetching: false,
    fetchError: payload,
  }))
  .handleAction(actions.fetch.success, (state, { payload }) => ({
    ...state,
    isFetching: false,
    hasFetched: true,
    sessions: payload,
  }))
  .handleAction(actions.sessionChange, (state, { payload }) => {
    if (!state.sessions) {
      return { ...state, sessions: [payload] };
    }
    const existing = state.sessions.findIndex((n) => n.id === payload.id);

    if (existing < 0)
      return { ...state, sessions: [...state.sessions, payload] };

    const newUsersessions = [
      ...state.sessions.slice(0, existing),
      payload,
      ...state.sessions.slice(existing + 1),
    ];

    return {
      ...state,
      sessions: newUsersessions.sort((a, b) =>
        a.displayName.localeCompare(b.displayName),
      ),
    };
  })
  .handleAction(actions.sessionEnded, (state, { payload }) => {
    if (!state.sessions) {
      return { ...state, sessions: [] };
    }

    const existing = state.sessions.findIndex((n) => n.id === payload);

    if (existing < 0) return state;

    return {
      ...state,
      sessions: [
        ...state.sessions.slice(0, existing),
        ...state.sessions.slice(existing + 1),
      ],
    };
  });

export default reducer;
